//@ helpers
const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const DateHelper = require('utilities/dateHelper');
const moment = require('moment');
const { DATE_FORMAT_API, CIC_CHANNEL , CODIGO_FAMILIAR_PRODUCTOS } = require('constants/index');
//@ constants
const { API_ENTERPRISE_NUMBER,
        API_CENTER,
         } = require('constants/index');
const { CUENTA_CARGO_CANAL } = require('constants/contactCenter/modifyCardAccount');

const reset = () => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_RESET
});

const setVisibleStep = (data) => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_SET_VISIBLE_STEP,
    payload: {
        data
    }
});

 const setCurrentAccount = (currentAccountId) => ({
     type: actionTypes.MODIFY_CARD_ACCOUNT_SET_CURRENT_ACCOUNT,
     payload: {
         currentAccountId
     }
 });

const setNewAccount = (newAccountId) => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_SET_NEW_ACCOUNT,
    payload: {
        newAccountId
    }
});

const validateStep = (data) => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_VALIDATE_STEP,
    payload: {
        data
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const getAccountDetailsRequest = () => ({
    type: actionTypes.ASSOCIATED_CARD_ACCOUNT_DETAILS_REQUEST
});

const getAccountDetailsSuccess = (data) => ({
    type: actionTypes.ASSOCIATED_CARD_ACCOUNT_DETAILS_SUCCESS,
    payload: {
        data
    }
});

const getAccountDetailsFailure = (error) => ({
    type: actionTypes.ASSOCIATED_CARD_ACCOUNT_DETAILS_FAILURE,
    payload: {
        error
    }
});

const modifyRequest = () => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_REQUEST
});

const modifySuccess = (data) => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_SUCCESS,
    payload: {
        data
    }
});

const modifyFailure = (error) => ({
    type: actionTypes.MODIFY_CARD_ACCOUNT_FAILURE,
    payload: {
        error
    }
});

const getAssociatedAccountDetails = (cardId, accountId) => (dispatch, getState) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const codban = immAccount.getIn(['ibanComplex', 'codbban']) + "          ";
        const requestData = {
                query: {
                    "empresa": API_ENTERPRISE_NUMBER,
                    "canalMarco": CIC_CHANNEL,
                    "contratoTarjeta": {
                        "centro": {
                            "empresa": API_ENTERPRISE_NUMBER,
                            "centro": API_CENTER
                        },
                        "producto": immCard.getIn(['contract', 'product']),
                        "numerodecontrato": immCard.getIn(['contract', 'number'])
                    },
                    "persona": {
                        "tipodepersona": "",
                        "codigodepersona": ""
                    },
                    "pan": immCard.get('number'),
                    "ctasCliente": {
                        "cuenta": [{
                            "criterios": {
                            "c2": {
                                "tipsitu": immCard.getIn(['criteria', 'c2','tipsitu'])
                            },
                            "cvinculados": {
                                "tipoVinculado": immCard.getIn(['filters', 'valid']) ? "S" : "N",
                                "vinculado": "1"
                            }
                            },
                            "descripcion": immAccount.get('description'),
                            "filtros": {
                                "bloque": "",
                                "valido": immCard.getIn(['filters', 'valid']) ? "S" : "N"
                            },
                            "saldos": {
                            "limite": {
                                "importe": 0,
                                "divisa": immCard.getIn(['availableBalance', 'currency'])
                            },
                            "saldoactual": {
                                "importe": "0",
                                "divisa": immCard.getIn(['availableBalance', 'currency'])
                            },
                            "saldocontnatural": {
                                "importe": 0,
                                "divisa": immCard.getIn(['availableBalance', 'currency'])
                            }
                            },
                            "codigoDeFamiliaProductos": CODIGO_FAMILIAR_PRODUCTOS,
                            "cuenta": {
                                "pais": immAccount.getIn(['ibanComplex', 'pais']),
                                "digitodecontrol": immAccount.getIn(['ibanComplex', 'digitodecontrol']),
                                "codbban": codban
                            }
                        }]
                    }
                }
            };

        dispatch(getAccountDetailsRequest());
        return APIPost({
            dispatch,
            endpoint: 'associatedCreditAccountDetails',
            params: requestData
        })
        .then((response) => dispatch(getAccountDetailsSuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(getAccountDetailsFailure(response.error));
            } else {
                throw response;
            }
        });
}

const postModify = (cardId, accountId) => (dispatch, getState) => {
    const callback = (dispatch, getState, token) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const associatedAccountDetails = getState().creditModifyAccount.get('associatedAccountDetails');
        const fechaAlta = associatedAccountDetails.getIn(['datoFecaltal',0])+"-"+associatedAccountDetails.getIn(['datoFecaltal',1])+"-"+associatedAccountDetails.getIn(['datoFecaltal',2])
        const fetchDate = DateHelper.parseDate(fechaAlta);
        const modifiedDate =  moment(fetchDate).format(DATE_FORMAT_API);
        const pan = immCard.get('number').replace(/ /g,'') + "   ";
        const requestData = {
                query: {

                "canal": CUENTA_CARGO_CANAL,
                "contratoTarjeta": {
                    "centro": {
                        "centro": API_CENTER,
                        "empresa": API_ENTERPRISE_NUMBER
                    },
                    "numerodecontrato": immCard.getIn(['contract', 'number']),
                    "producto": immCard.getIn(['contract', 'product'])
                },
                "ctaEnNuevaCuentaCargo": {
                    "codbban": immAccount.getIn(['ibanComplex', 'codbban'])+ "          ",
                    "digitodecontrol": immAccount.getIn(['ibanComplex', 'digitodecontrol']),
                    "pais": associatedAccountDetails.getIn(['cuenta', 'pais'])
                },
                "cuentaCargoPrincipal": {
                    "codPersona": "",
                    "codRelacionContratos": associatedAccountDetails.get('codRelacionContratos'),
                    "ctaEnCuentaPrincipal": {
                        "codbban": associatedAccountDetails.getIn(['cuenta', 'codbban']),
                        "digitodecontrol": associatedAccountDetails.getIn(['cuenta', 'digitodecontrol']),
                        "pais": associatedAccountDetails.getIn(['cuenta', 'pais'])
                    },
                    "fechaAlta": modifiedDate,
                    "fechaCO": associatedAccountDetails.get('jfechaco'),
                    "numeroSecuencia": associatedAccountDetails.get('numSecuencia'),
                    "tablaCuenta": associatedAccountDetails.get('tablaCuenta'),
                    "tipoOperacion": associatedAccountDetails.get('tipoOperacion')
                },
                "pan": pan,
                "persona": {
                    "codigodepersona": "",
                    "tipodepersona": ""
                },
                "subTipoProducto": immCard.get('productSubType'),
                "token": token
                }
            };

        dispatch(modifyRequest());
        return APIPost({
            dispatch,
            endpoint: 'creditCardModifyAssociatedAccountConfirmation',
            params: requestData
        })
        .then((response) => dispatch(modifySuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(modifyFailure(response.error));
            } else {
                throw response;
            }
        });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);

}


module.exports = {
    reset,
    setWillCancel,
    setVisibleStep,
    setCurrentAccount,
    setNewAccount,
    validateStep,
    postModify,
    getAssociatedAccountDetails
}
